export default __webpack_public_path__ + "static/media/sportsbra-small-right.2263d042.jpg";